import gql from "graphql-tag";

export const RandomCategoriesByFacetQuery = gql`
  query RandomCategoriesByFacet($facet: String, $limit: Int) {
    randomCategoriesByFacet(facet: $facet, limit: $limit) {
      uid
      slug
      nameTitleCased
      basePath
      slug
    }
  }
`;
